'use client';
import config from '@haaretz/l-config';
import useUser from '@haaretz/s-atoms/user';
import useClientQuery from '../../common/useClientQuery';
/**
 * Get personal list data
 *
 * @public
 */ export default function useUpdateReadingHistory({ inView, variables, clientOptions }) {
    const user = useUser('cookieValue');
    const url = `${config.get('personalization')}/update-reading-history`;
    return useClientQuery({
        url,
        cacheKey: 'updateReadingHistory',
        variables,
        clientOptions: {
            ...clientOptions,
            enabled: (clientOptions?.enabled ?? true) && user.isLoggedIn && inView && !!(variables.viewedArticleIds || variables.readArticleId),
            gcTime: 0
        }
    });
}

//# sourceMappingURL=useUpdateReadingHistory.js.map